import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseReportService } from '@app/api/api-services/base-report.service';
import { TraineeSuccessReportRequestApiModel } from '@app/api/api-models/reports/trainee-success/TraineeSuccessReportRequestApiModel';
import { TraineeSuccessReportApiModel } from '@app/api/api-models/reports/trainee-success/TraineeSuccessReportApiModel';
import { TraineeSuccessReportFiltersApiModel } from '@app/api/api-models/reports/trainee-success/TraineeSuccessReportFiltersApiModel';

@Injectable()
export class TraineeSuccessReportService extends BaseReportService<
  TraineeSuccessReportFiltersApiModel,
  TraineeSuccessReportRequestApiModel,
  TraineeSuccessReportApiModel
> {
  public readonly apiUrl = 'reports/trainee-success';

  public getReport(request: TraineeSuccessReportRequestApiModel): Observable<TraineeSuccessReportApiModel> {
    return super.getReport(request.serialize());
  }
}
